<ion-app [ngClass]="{'light': !isDarkmode, 'dark': isDarkmode}">

  <afs-confirm backdropClass="backdrop"></afs-confirm>
  
  @if (authSrv.isSecondSplash) {
    <app-splash [finish]="authSrv.secondSplashAnimation" style="z-index: 11;"></app-splash>
  }
  @if (quickSearchSrv.isQuickSearchOpen) {
    <app-quick-search></app-quick-search>
  }
  @if (!isLogin && !menu.showNothing) {
    <div>
      @if (!menu.isCustomer && menu.showNavigation) {
        <app-navigation></app-navigation>
      }
    </div>
  }
  <ion-router-outlet></ion-router-outlet>
  
</ion-app>